import React, { Fragment } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  ListItemIcon,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { styledListIcon } from "./styledListIcon";

export const StyledListItemIcon = styledListIcon(ListItemIcon);

export const ActivityLoader: React.FC = () => (
  <Box position="relative" data-testid="ActivityPanel__Loader">
    <List>
      {[1, 2, 3].map((v, idx) => (
        <Fragment key={`loader-item-${v}`}>
          {idx !== 0 && <Divider />}
          <ListItem>
            <StyledListItemIcon>
              <Skeleton
                variant="circle"
                width={24}
                height={24}
                animation="wave"
              />
            </StyledListItemIcon>
            <ListItemText
              primary={
                <Skeleton
                  variant="text"
                  component="span"
                  width="100%"
                  height={24}
                  animation="wave"
                />
              }
              secondary={
                <Skeleton
                  variant="text"
                  component="span"
                  width="50%"
                  height={24}
                  animation="wave"
                />
              }
            />
          </ListItem>
        </Fragment>
      ))}
    </List>
  </Box>
);
